// use routes
import { PATH_DASHBOARD } from '../routes/paths';

// Grouped settings menu — order matters: most-used items first within each group.
// `group` and `description` are used by SettingsPopover for the grouped popover layout.
// SettingsMenu (sidebar) ignores these fields and renders a flat list.

export const MENU_OPTIONS = [
    // --- Practice Setup ---
    {
        label: 'Practice Details',
        description: 'Name, address, contact info, and branding',
        value: 'practice_details',
        linkTo: PATH_DASHBOARD.user.practice,
        icon: 'solar:buildings-2-bold-duotone',
        group: 'Practice Setup',
    },
    {
        label: 'Treatments',
        description: 'Treatment types, pricing, and colours',
        value: 'practice_treatments',
        linkTo: PATH_DASHBOARD.user.practiceTreatment,
        icon: 'mdi:dentist',
        group: 'Practice Setup',
    },
    {
        label: 'Team Members',
        description: 'Manage users, roles, and permissions',
        value: 'practice_users',
        linkTo: PATH_DASHBOARD.user.practiceUser,
        icon: 'solar:users-group-rounded-bold-duotone',
        group: 'Practice Setup',
    },
    {
        label: 'Integrations',
        description: 'Google, WhatsApp, Stripe, and more',
        value: 'practice_integration',
        linkTo: PATH_DASHBOARD.user.integration,
        icon: 'solar:plug-circle-bold-duotone',
        group: 'Practice Setup',
    },
    {
        label: 'Phone system',
        description: 'Calls into Call Logs, handsets and who is told',
        value: 'practice_phone_system',
        linkTo: PATH_DASHBOARD.user.phoneSystem,
        icon: 'solar:phone-calling-rounded-bold-duotone',
        group: 'Practice Setup',
    },
    // --- Communication ---
    {
        label: 'Automations',
        description: 'Follow-ups that send themselves, by treatment and channel',
        value: 'practice_automations',
        linkTo: PATH_DASHBOARD.user.automations,
        icon: 'solar:bolt-circle-bold-duotone',
        group: 'Communication',
    },
    {
        label: 'Templates',
        description: 'Email and WhatsApp templates, plus defaults for links',
        value: 'practice_templates',
        linkTo: PATH_DASHBOARD.user.templates,
        icon: 'solar:chat-round-dots-bold-duotone',
        group: 'Communication',
    },
    {
        label: 'Chatbot',
        description: 'Website chatbot configuration',
        value: 'practice_chatbot',
        linkTo: PATH_DASHBOARD.user.practiceChatbot,
        icon: 'ic:round-smart-toy',
        group: 'Communication',
    },
    {
        label: 'Call Scripts',
        description: 'Guided scripts for inbound and outbound calls',
        value: 'call_script_v2',
        linkTo: PATH_DASHBOARD.user.callScriptsV2,
        icon: 'solar:document-text-bold-duotone',
        group: 'Communication',
    },
    // --- Practice Settings ---
    // 'Auto Reminders' entry removed in Phase 1 of PracticeAutoReminder deprecation
    // (see /Users/admin/Desktop/2026-06-08-auto-reminder-removal-rca.md). Page files
    // and routes are intentionally kept until Phase 2 BE removal.
    {
        label: 'Notifications',
        description: 'Email, SMS, and in-app alert preferences',
        value: 'notification_settings',
        linkTo: PATH_DASHBOARD.user.notification,
        icon: 'solar:bell-bing-bold-duotone',
        group: 'Practice Settings',
    },
    {
        label: 'Preferences',
        description: 'Practice-wide toggles and defaults',
        value: 'practice_preferences',
        linkTo: PATH_DASHBOARD.user.practicePreferences,
        icon: 'solar:tuning-2-bold-duotone',
        group: 'Practice Settings',
    },
    // Track E (template convergence — 2026-04-26): the "Form Delivery
    // Templates" settings entry was retired. Templates are now managed in
    // the unified Template Manager page under
    // ``PATH_DASHBOARD.campaignsManager.templates`` — open it from the
    // Send Forms wizard's "Edit templates" link, which deep-links with
    // ``?purpose=FORM_DELIVERY&form_type=...``.
    // --- More ---
    {
        label: 'Consent Forms',
        description: 'Digital consent form builder',
        value: 'practice_consent',
        linkTo: PATH_DASHBOARD.user.consent,
        icon: 'solar:document-add-bold-duotone',
        group: 'More',
    },
    {
        label: 'Payment Plans',
        description: 'Patient financing and payment options',
        value: 'Practice-payment-plans',
        linkTo: PATH_DASHBOARD.user.loan,
        icon: 'solar:wallet-money-bold-duotone',
        group: 'More',
    },
    {
        label: 'Export Data',
        description: 'Download leads and reports as CSV',
        value: 'export_to_csv',
        linkTo: PATH_DASHBOARD.user.exportToCsv,
        icon: 'solar:download-minimalistic-bold-duotone',
        group: 'More',
    },
];
